import React from 'react'

const AnalyticsGrowthIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='35'
    height='36'
    viewBox='0 0 35 36'
    fill='none'
    {...props}
  >
    <path
      d='M4.375 31.4941V28.5775L7.29167 25.6608V31.4941H4.375ZM10.2083 31.4941V22.7441L13.125 19.8275V31.4941H10.2083ZM16.0417 31.4941V19.8275L18.9583 22.7806V31.4941H16.0417ZM21.875 31.4941V22.7806L24.7917 19.8639V31.4941H21.875ZM27.7083 31.4941V16.9108L30.625 13.9941V31.4941H27.7083ZM4.375 23.9473V19.8275L14.5833 9.61914L20.4167 15.4525L30.625 5.24414V9.36393L20.4167 19.5723L14.5833 13.7389L4.375 23.9473Z'
      fill='currentcolor'
    />
  </svg>
)

export default AnalyticsGrowthIcon
